import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { mobileApp } from '@sorare/core/src/lib/glossary';

export const useCannotTrade = () => {
  const { currentUser } = useCurrentUserContext();
  const { isIosApp, isMarketAuthorizedIosApp } = useIsMobileApp();

  return () => {
    if (isIosApp && !isMarketAuthorizedIosApp) return mobileApp.startTrading;
    if (!currentUser) return null;

    return null;
  };
};
